import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { Switch } from "components"
import { changeBranchAutoConfirm } from "services"
import { toggleAutoConfirm, updateUserAccountInfo } from "@redux"
import classes from "./SsAutoCheckout.module.scss"

const SsAutoCheckout = () => {
  const [t] = useTranslation()

  const { cashierBranches, branchId } =
    useSelector(state => state.userAccountInfo)

  const dispatch = useDispatch()

  const [sending, setSending] = useState()

  const handleToggleAutoConfirm = async () => {
    setSending(true)

    dispatch(updateUserAccountInfo({
      cashierBranches:
        cashierBranches.map(cashierBranch =>
          cashierBranch._id === branchId
            ?
            {
              ...cashierBranch,
              autoConfirmOrders: !checked
            }
            : cashierBranch
        )
    }))


    try {
      await changeBranchAutoConfirm(branchId, { autoConfirmOrders: !checked })
    } catch (err) {
      console.log(err)

      toast.error(t("عملیات انجام نشد"))

      dispatch(toggleAutoConfirm())
    }

    setSending(false)
  }

  const checked =
    cashierBranches.some(cashierBranch =>
      cashierBranch.autoConfirmOrders &&
      cashierBranch._id === branchId
    )

  return (
    <div className={classes["row"]}>
      <span>{t("تایید_خودکار_سفارشات_مهمان")}</span>
      <Switch
        disabled={sending}
        onClick={handleToggleAutoConfirm}
        checked={checked}
      />
    </div>
  )
}

export default SsAutoCheckout